<template>
  <q-page padding>
    <ImpressaoAnexos
      v-if="numeroAnexos"
      :anexos="listaAnexos"
      :numeroAnexos="numeroAnexos"
    />
  </q-page>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import ImpressaoAnexos from "../components/ImpressaoAnexos.vue";

export default {
  components: {
    ImpressaoAnexos,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const ptId = route.params.ptId;
    const pt = ref(false);
    const listaAnexos = ref([]);
    const numeroAnexos = ref(0);

    const buscarDetalhePt = async () => {
      store.dispatch("pdt/hiddenHeader", false);

      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;
      if (resposta.data.resultado.dados.anexos) {
        listaAnexos.value = resposta.data.resultado.dados.anexos;
      } else {
        listaAnexos.value = [];
        return;
      }
      numeroAnexos.value = listaAnexos.value.length;
      for (let i = 0; i <= numeroAnexos.value; i++) {
        if (i <= numeroAnexos.value) {
          let n = i * 4;
          if (n > 0) {
            listaAnexos.value[n - 1].quebra = { break: true };
          }
        }
      }
    };

    onMounted(buscarDetalhePt);

    return {
      ptId,
      pt,
      buscarDetalhePt,
      listaAnexos,
      numeroAnexos,
    };
  },
};
</script>
